import React from 'react'
import PropTypes from 'prop-types';
import TagsStore from 'Stores/TagsStore'
import Select from 'rctui/Select';

class Tags extends React.Component {
  static defaultProps = {
    context: null,
    disabled: false,
    name: '',
    value: ''
  };

  static propTypes = {
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    value: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      tags: [],
    };
    this._onChange = this._onChange.bind(this);
    this._onChangeAvailable = this._onChangeAvailable.bind(this);
    this.onApplyLatestClick = this.onApplyLatestClick.bind(this);
  }

  componentDidMount() {
    TagsStore.addChangeListener(this.props.context, this._onChangeAvailable);
    this._onChangeAvailable();
  }

  componentWillUnmount() {
    TagsStore.removeChangeListener(this.props.context, this._onChangeAvailable);
  }

  _onChange(idx, val) {
    let values = this.props.value.split(",");

    if (idx === 0) {
      if (values.length >= 0) {
        if (val === undefined) {
          values.splice(0, 1);
        } else {
          values.splice(0, 1, val);
        }
      } else if (val !== undefined) {
        values.push(val);
      }
    }
    if (idx === 1) {
      if (values.length >= 1) {
        if (val === undefined) {
          values.splice(1, 1);
        } else {
          values.splice(1, 1, val);
        }
      } else if (val !== undefined) {
        values.push(val);
      }
    }
    if (idx === 2) {
      if (values.length >= 2) {
        if (val && val.length > 0) {
          values = [values[0], values[1]].concat(val);
        } else {
          values = [values[0], values[1]];
        }
      } else if (val && val.length > 0) {
        values = values.concat(val);
      }
    }

    let result = [];
    values.forEach((item) => {
      if (result.indexOf(item) < 0 && item !== '') {
        result.push(item);
      }
    });

    this.props.onChange(this.props.name, result.join(","));
  }

  _onChangeAvailable() {
    let tags = TagsStore.getAll(this.props.context);
    if (tags) {
      this.setState({tags: tags.slice(0).sort()});
    }
  }

  getLatest() {
    let latest = this.props.latest;

    let indices = [];
    let maxUsed = 0, maxIdx1 = -1;

    for (let i = latest.length - 1; i >= 0; i--) {
      if (latest[i].Used > maxUsed) {
        maxUsed = latest[i].Used;
        maxIdx1 = i;
      }
    }

    let maxIdx2 = -1;
    maxUsed = 0;

    for (let i = latest.length - 1; i >= 0; i--) {
      if (latest[i].Used > maxUsed && i !== maxIdx1) {
        maxUsed = latest[i].Used;
        maxIdx2 = i;
      }
    }

    if (maxIdx1 >= 0) {
      indices.push(maxIdx1);
    }
    if (maxIdx2 >= 0) {
      indices.push(maxIdx2);
    }

    for (let i = latest.length - 1; i >= 0; i--) {
      if (i !== maxIdx1 && i !== maxIdx2) {
        indices.push(i);
        if (indices.length === 5) {
          break;
        }
      }
    }

    return indices.map((i) =>
      <a href="#" key={i} onClick={(e) => this.onApplyLatestClick(latest[i].Id, e)}>
        [{latest[i].Id}]
      </a>);
  }

  onApplyLatestClick(id, e) {
    e.preventDefault();
    this.props.onChange && this.props.onChange(this.props.name, id);
  }

  render() {
    let values = this.props.value.split(",");
    let value0 = '', value1 = '', valuesRest = [];

    if (values.length > 0) {
      value0 = values[0];
    }
    if (values.length > 1) {
      value1 = values[1];
    }
    if (values.length > 2) {
      valuesRest = values.slice(2);
    }

    let data0 = this.state.tags;
    let data1 = data0.filter((v) => v !== value0);
    let data2 = data0.filter((v) => v !== value0 && v !== value1);

    return (
      <div>
        <Select grid={1 / 3}
                sep={null}
                data={data0}
                filterAble
                name={this.props.name}
                value={value0}
                onChange={this._onChange.bind(this, 0)}
                readOnly={this.props.disabled}
                className={this.props.className}
        />
        <Select grid={1 / 3}
                sep={null}
                data={data1}
                filterAble
                name={this.props.name}
                value={value1}
                onChange={this._onChange.bind(this, 1)}
                readOnly={this.props.disabled}
                className={this.props.className}
        />
        <Select mult grid={1 / 3}
                sep={null}
                data={data2}
                filterAble
                name={this.props.name}
                value={valuesRest}
                onChange={this._onChange.bind(this, 2)}
                readOnly={this.props.disabled}
                className={this.props.className}
        />
      </div>
    );
  }
}

export default Tags;



// WEBPACK FOOTER //
// ./src/js/Component/Tags.jsx